import React , {useEffect} from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {

const {t} = useTranslation();

useEffect(() => {
}, []);

  return (
    <div className="section_not_found text-center p-8 mt-5 mb-5 pt-5">
      <h1 className="text-4xl font-bold mb-4">{t("page_not_found_title")}</h1>
      <p className="mb-6">{t("page_not_found_message")}</p>
      <Link to="/" className="text-blue-600 underline d-block mb-5 pb-5">
        {t("go_back_home")}
      </Link>
    </div>
  );
};

export default NotFound;